import { cloneElement, filterElements } from "../util/Utils";
import type { FilterSectionLoadedEvent } from "../multifiltering/FilterTypes";
import { HeurekaElementFactory } from "../util/HeurekaElementFactory";
import { events } from "../events";
import { SvelteFacet } from "../filter/SvelteFacet";

const ID_SMART_SORTING = "heureka_smartSorting";

export class SmartSorting {
  private static readonly factory = HeurekaElementFactory.byId(ID_SMART_SORTING, SmartSorting);

  /*               */
  constructor(
    private readonly elem: HTMLElement,
    private readonly matchedValues: HTMLInputElement[] = SmartSorting.findMatches(elem),
  ) {}

  /*                  */

  static template(rootElement?: ParentNode | null) {
    return SmartSorting.factory.pick(undefined, rootElement);
  }

  /*               */

  static register() {
    events.onFilterSectionLoaded(SmartSorting.initAll);
  }

  static initAll(event: FilterSectionLoadedEvent, rootElement?: ParentNode) {
    SmartSorting.template(rootElement)?.init();
  }

  protected init() {
    return this;
  }

  /*                       */
  get relevantValues(): HTMLInputElement[] {
    return this.matchedValues.map(cloneElement);
  }

  public static findMatches(elem: HTMLElement): HTMLInputElement[] {
    /*                                           */
    const facetName = elem.querySelector<HTMLInputElement>(`input[name]`)?.name;
    if (facetName) {
      const categoryFacet = SvelteFacet.facetName(facetName);
      const unSelectedFacetValues = categoryFacet?.unselectedValues.map((value) => value.facetValue);
      if (unSelectedFacetValues) {
        return filterElements<HTMLInputElement>(
          "input",
          (input) => {
            return this.findMatchingElement(facetName, unSelectedFacetValues, input.value);
          },
          elem,
        );
      }
    }
    return [];
  }

  private static findMatchingElement(
    facetName: string,
    unSelectedFacetValues: HTMLInputElement[],
    inputValue: string,
  ): HTMLInputElement | undefined {
    return unSelectedFacetValues.find((input) => {
      return input.value === inputValue;
    });
  }
}
